import { useState } from 'react';
import { Form, IconButton, Icon } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { RiSendInsLine } from '@remixicon/react';
import {
  useOpenAiChat,
  useSetAiChatInitialMessage,
} from '@blend-ed/blendxplatform';

import messages from '../messages';

import './AiQueryBar.scss';

const AiQueryBar = ({ placeholder }) => {
  const { formatMessage } = useIntl();
  const openAiChat = useOpenAiChat();
  const setInitialMessage = useSetAiChatInitialMessage();
  const [text, setText] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const submit = (e) => {
    e?.preventDefault?.();
    const trimmed = text.trim();
    if (!trimmed) { return; }
    setInitialMessage(trimmed);
    openAiChat();
    setText('');
    setIsFocused(false);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className={`ai-query-bar-shell${isFocused ? ' ai-query-bar-shell--focused' : ''}`}>
      <div className="ai-query-bar__halo" aria-hidden="true" />
      <form className="ai-query-bar" onSubmit={submit}>
        <Form.Control
          as="textarea"
          rows={isFocused ? 2 : 1}
          controlClassName="ai-query-bar__input"
          placeholder={placeholder || formatMessage(messages.aiQueryPlaceholder)}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => { if (!text.trim()) { setIsFocused(false); } }}
          onKeyDown={onKeyDown}
        />
        <IconButton
          type="submit"
          src={RiSendInsLine}
          iconAs={Icon}
          variant="soft-primary"
          className="ai-query-bar__send"
          disabled={!text.trim()}
          alt={formatMessage(messages.aiQuerySendLabel)}
        />
      </form>
    </div>
  );
};

export default AiQueryBar;
